if (!window.customElements.get('zp05-facet-link')) {
  class Zp05FacetLink extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin || link.classList.contains('is-disabled')) return;

      event.preventDefault();

      const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
      if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      const templateView = document.querySelector('[data-zp05-template]')?.dataset.zp05Template;
      if (templateView === 'zp005') url.searchParams.set('view', templateView);
      url.searchParams.set('section_id', this.getAttribute('section-id'));

      const popover = this.closest('x-popover');
      if (popover && typeof popover.hide === 'function') popover.hide();

      document.dispatchEvent(new CustomEvent('facet:update', { detail: { url } }));
    };
  }

  window.customElements.define('zp05-facet-link', Zp05FacetLink);
}

// Keep the active test template and filters when Shopify changes the locale.
const preserveLocalizationView = (nextUrl = window.location.href) => {
  if (document.querySelector('[data-zp05-template]')?.dataset.zp05Template !== 'zp005') return;
  const url = new URL(nextUrl, window.location.origin);
  url.searchParams.set('view', 'zp005');
  url.searchParams.delete('section_id');

  document.querySelectorAll('form[action$="/localization"]').forEach((form) => {
    const returnTo = form.elements.namedItem('return_to');
    if (returnTo) returnTo.value = url.pathname + url.search;
  });
};

preserveLocalizationView();
document.addEventListener('facet:update', (event) => preserveLocalizationView(event.detail.url));
document.addEventListener('submit', (event) => {
  if (event.target instanceof HTMLFormElement && new URL(event.target.action).pathname.endsWith('/localization')) {
    preserveLocalizationView();
  }
}, true);

// Use the official TrustBox renderer, reusing the site's existing bootstrap.
const loadHeroTrustpilot = () => {
  if (!window.Trustpilot?.loadFromElement) return;
  const widgets = [...document.querySelectorAll('[data-zp05-trustpilot]')]
    .filter((widget) => !widget.querySelector('iframe'));
  widgets.forEach((widget) => window.Trustpilot.loadFromElement(widget, true));
};

loadHeroTrustpilot();
// The Trustpilot app also discovers widgets when its bootstrap loads later.
document.querySelector('script[src*="tp.widget.bootstrap"]')
  ?.addEventListener('load', loadHeroTrustpilot, { once: true });
document.addEventListener('shopify:section:load', loadHeroTrustpilot);
